import Axios from "axios";
var CategoryService = (function () {
    function CategoryService() {
    }
    CategoryService.prototype.getCategoryTree = function () {
        return Axios.get("supplierclientapi/suppliergoodstype/type_list");
    };
    CategoryService.prototype.getCategoryIconList = function () {
        return Axios.get("supplierclientapi/suppliergoodstype/icon_list");
    };
    CategoryService.prototype.getCategoryList = function (params) {
        return Axios.get("supplierclientapi/suppliergoodstype/list", { params: params });
    };
    CategoryService.prototype.edit = function (params) {
        return Axios.post("supplierclientapi/suppliergoodstype/edit", params);
    };
    CategoryService.prototype.save = function (params) {
        return Axios.post("supplierclientapi/suppliergoodstype/save", params);
    };
    CategoryService.prototype.creatIcon = function (params) {
        return Axios.post("supplierclientapi/suppliergoodstype/create_icon", params);
    };
    CategoryService.prototype.change = function (params) {
        return Axios.post("supplierclientapi/suppliergoodstype/change", params);
    };
    CategoryService.prototype.getDeliverCategory = function (params) {
        return Axios.get("supplierclientapi/deliveryorder/business_goods_type", { params: params });
    };
    CategoryService.prototype.getEntrustDeliverCategory = function (params) {
        return Axios.get("supplierclientapi/entrust_delivery_order/business_goods_type", { params: params });
    };
    CategoryService.prototype.deleteIcon = function (params) {
        return Axios.post("supplierclientapi/suppliergoodstype/delete_icon", params);
    };
    CategoryService.createInstance = function () {
        CategoryService.getInstance();
    };
    CategoryService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return CategoryService;
}());
export default CategoryService;
